export const TITLE = 'Requisições atendidas pelo Usuário';
export const LABEL = 'Requisições';
